/*
 * Hero reveal — depth flourish for the pinned hero.
 *
 * The pin itself is pure CSS (the hero's section wrapper is position: sticky, see typography.css);
 * the page content scrolls up and over the held hero. This adds the scrubbed depth cue as it's
 * covered: the background image eases in a touch and a dark veil fades up, so the hero appears to
 * recede. Bookends the footer reveal.
 *
 * Runs across the first viewport of scroll (start scroll 0, end +100%) — a distance-based range that
 * sidesteps sticky-measurement quirks. No ScrollTrigger pin (CSS handles it), no scrub+toggleActions
 * mix — per GSAP best practice. Requires gsap + ScrollTrigger (<head>). <wp-hero-reveal>
 * (display: contents) wraps the [data-hero] section; built in connectedCallback inside
 * gsap.matchMedia() (motion-allowed only — under reduced motion the CSS makes the hero a normal,
 * non-pinned section) and reverted in disconnectedCallback.
 */
(function () {
  if (!window.gsap || !window.ScrollTrigger || customElements.get('wp-hero-reveal')) return;

  class WpHeroReveal extends HTMLElement {
    connectedCallback() {
      const hero = this.querySelector('[data-hero]');
      if (!hero) return;
      const img = hero.querySelector(':scope > img, :scope > svg'); // the background, not the monogram
      const veil = hero.querySelector('[data-hero-veil]');

      this.mm = gsap.matchMedia();
      this.mm.add('(prefers-reduced-motion: no-preference)', () => {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: hero,
            start: 'top top',
            end: '+=100%',
            scrub: true,
            invalidateOnRefresh: true,
          },
        });

        // Image scale stays >= 1 so the object-cover image never reveals its edges.
        if (img) tl.fromTo(img, { scale: 1 }, { scale: 1.08, ease: 'none' }, 0);
        if (veil) tl.fromTo(veil, { opacity: 0 }, { opacity: 0.5, ease: 'none' }, 0);
      });
    }

    disconnectedCallback() {
      if (this.mm) this.mm.revert();
      this.mm = null;
    }
  }

  customElements.define('wp-hero-reveal', WpHeroReveal);
})();
